import { useMutation } from '@tanstack/react-query'
import { switchCompany } from 'api/company'
import { useAuthContext } from 'components/auth'

export function useSwitchCompanyMutation() {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: (newCompanyId: number) => {
      if (!company) {
        throw new Error('Company not found')
      }

      return switchCompany(company.id, newCompanyId)
    },
    onSuccess: () => {
      window.location.replace('/home')
    },
  })
}
